// One line per postseason event for a team: its seed in each bracket and
// how far it got, or that it missed out. postseason: summary/postseason.
// Returns [{key, text, tone}] with tone 'good', 'bad' or ''.
export function postseasonStatus(league, postseason, teamId) {
    if (!postseason) return [];
    const lines = [];
    if (postseason.champion === teamId) {
        lines.push({ key: 'champ', tone: 'good', text: 'Season champion!' });
    }

    const brackets = Object.values(postseason.brackets ?? {});
    for (const b of brackets) {
        const entry = b.rounds[0].matchups.flatMap(m => [m.top, m.bottom]).find(e => e?.team === teamId);
        if (!entry) continue;
        const region = b.regionNames && entry.region !== undefined ? `, ${b.regionNames[entry.region]} Region` :
            entry.conference && league.conferences?.[entry.conference] ? `, ${league.conferences[entry.conference].name}` : '';
        let text = `${b.name}: No. ${entry.seed} seed${region}`;
        let tone = '';
        const lost = b.rounds.flatMap(r => r.matchups).find(m =>
            m.winner && m.winner !== teamId && (m.top?.team === teamId || m.bottom?.team === teamId));
        if (b.champion === teamId) {
            text += b.style === 'conference' ? ' · won the title and an automatic bid' : ' · won it all';
            tone = 'good';
        } else if (lost) {
            const series = lost.bestOf > 1 ? ` ${Math.min(lost.wins.top, lost.wins.bottom)}-${Math.max(lost.wins.top, lost.wins.bottom)}` : '';
            text += ` · lost${series} in the ${b.rounds[lost.round].name}`;
            tone = 'bad';
        } else {
            text += ' · still alive';
        }
        lines.push({ key: b.id, text, tone });
    }

    const conf = league.conferences ? Object.values(league.conferences).find(c => c.teamIds.includes(teamId)) : null;
    const confBracket = conf && postseason.brackets?.[`conf-${conf.id}`];
    if (conf && brackets.some(b => b.style === 'conference') && !lines.some(l => l.key === confBracket?.id)) {
        lines.push({ key: 'conf-miss', tone: 'bad', text: `Didn't qualify for the ${conf.name} Tournament.` });
    }
    if (postseason.selection && !postseason.selection.field.some(e => e.team === teamId)) {
        const bubble = postseason.selection.firstFourOut.includes(teamId);
        lines.push({ key: 'not-selected', tone: 'bad', text: `Not selected for the National Tournament${bubble ? ' (one of the first four out)' : ''}.` });
    }
    if (postseason.brackets?.playoffs && !lines.some(l => l.key === 'playoffs')) {
        lines.push({ key: 'missed', tone: 'bad', text: 'Missed the playoffs.' });
    }
    return lines;
}
